import {setGraneroTarget} from '@apps-common/geocorn-sdk/api';

const urls = {
  base: import.meta.env.VITE_API_BASE_URL ?? 'https://api.planet.com',
  basemaps: import.meta.env.VITE_BASEMAPS_API_BASE ?? '/basemaps/v1',
  // sceneTiles and basemapTiles configs look the same in prod, but internally they are 2 separate services (webtiles & yats)
  // this allows flexibility if we need to test with internal routes
  basemapTiles:
    import.meta.env.VITE_BASEMAPS_TILES_BASE_URL ??
    'https://tiles.planet.com/basemaps/v1',
  basemapTilesDomainTemplate:
    import.meta.env.VITE_BASEMAPS_TILES_DOMAIN_TEMPLATE ??
    'https://tiles{0-3}.planet.com/basemaps/v1',
  blobz: import.meta.env.VITE_BLOBZ_API_URL ?? '/apps/v0/b',
  data: import.meta.env.VITE_DATA_API_URL ?? '/data/v1',
  dataCollections:
    import.meta.env.VITE_DATA_COLLECTIONS_URL ??
    'https://services.sentinel-hub.com/api/v1/byoc/collections',
  destinations: import.meta.env.VITE_DESTINATIONS_API_URL ?? '/destinations/v1',
  explorerUtils: '/explorer-utils',
  features: setGraneroTarget(import.meta.env.VITE_GRANERO_TARGET ?? 'live'),
  orders: import.meta.env.VITE_ORDERS_API_URL ?? '/compute/ops/orders/v2',
  pdaAdmin: import.meta.env.VITE_PDA_ADMIN_URL ?? '/account/v1',
  sceneTiles:
    import.meta.env.VITE_SCENE_TILES_BASE_URL ??
    'https://tiles.planet.com/data/v1',
  sceneTilesDomainTemplate:
    import.meta.env.VITE_SCENE_TILES_DOMAIN_TEMPLATE ??
    'https://tiles{0-3}.planet.com/data/v1',
  subscriptions:
    import.meta.env.VITE_SUBSCRIPTIONS_API_URL ?? '/subscriptions/v1',
  configuration: 'https://services.sentinel-hub.com/api/v2/configuration',
  catalog: 'https://services.sentinel-hub.com/api/v1/catalog/1.0.0',
  process: 'https://services.sentinel-hub.com/api/v1/process',
  shServiceLocations:
    'https://services.sentinel-hub.com/api/v1/metadata/location',
};

export default urls;
